import { SpamScenarioId } from 'owa-junkmail-configuration';
import { assertNever } from 'owa-assert';

// Used to retrieve correct scenarioId string for store access
export default function getSpamScenarioIdKey(scenarioId: SpamScenarioId): string {
    switch (scenarioId) {
        case SpamScenarioId.BlockedSendersAndDomains:
            return 'BlockedSendersAndDomains';
        case SpamScenarioId.SafeSendersAndDomains:
            return 'SafeSendersAndDomains';
        case SpamScenarioId.SafeMailingLists:
            return 'SafeMailingLists';
        default:
            return assertNever(scenarioId);
    }
}
